// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "game-routes" + "." + "e2763538" + ".chunk.css";
};